import {cloneDeep, uniqueId} from 'lodash';
import {createImageObject} from '../utils';
import {intelFormConfig, designFormConfig} from '@/views/V2/image/market/utils/formConfig.js';
import {defaultIntelFormData, defaultDesignFormData} from '@/views/V2/image/market/utils/formData.js';
import {formatTaskData, formatRecordData} from '@/component/image/utils/format.js';
import {getTplOptions, checkValueExists} from '@/views/V2/image/market/utils/helper.js';

import {
    defaultIntelTarget,
    defaultDesignTarget,
    placeHolder,
    openIndustryByHot,
    submitTipObj
} from '@/views/V2/image/market/utils/constants.js';

export default {
    namespaced: true,
    state: {
        displayImg: [],
        placeHolder,
        submitTipObj,
        industryList: [],
        intelFormConfig: cloneDeep(intelFormConfig),
        designFormConfig: cloneDeep(designFormConfig),
        intelFormData: cloneDeep(defaultIntelFormData),
        designFormData: cloneDeep(defaultDesignFormData),
        intelFormCreated: false,
        preBgImgList: [],
        // preIntelFormData: {},
        // preDesignFormData: {},
        savedPrompt: '',
        targetCountData: {
            intelForm: cloneDeep(defaultIntelTarget),
            designForm: cloneDeep(defaultDesignTarget)
        },
        toolBarLoading: {
            intelForm: false,
            designForm: false
        },
        canSubmit: {
            intelForm: false,
            designForm: false
        },
        pageLoadingStatus: {
            show: false,
            title: ''
        },
        useWaterFall: false,
        useAsyncMode: false,
        pageNum: 1,
        scrollTop: 0
    },
    mutations: {
        UPDATE_COMMON_STATE(state, {key, value}) {
            state[key] = value;
        },
        UPDATE_MULTIPLE_STATES(state, updates) {
            for (let update of updates) {
                state[update.key] = update.value;
            }
        },
        UPDATE_FORM_DATA(state, {form, key, value}) {
            state[form] = {...state[form], [key]: value};
        },
        CHANGE_LOADING(state, data) {
            state.toolBarLoading = {...state.toolBarLoading, ...data};
        },
        CHANGE_CAN_SUBMIT(state, data) {
            state.canSubmit = {...state.canSubmit, ...data};
        },
        CHANGE_TARGET_COUNT(state, {form, value}) {
            state.targetCountData[form] = {...state.targetCountData[form], ...value};
        }
    },
    actions: {
        updateFormData({commit}, data) {
            const {form, key, value} = data;
            commit('UPDATE_FORM_DATA', {
                form,
                key,
                value
            });
        },
        changeLoading({commit}, data) {
            commit('CHANGE_LOADING', data);
        },
        changeDesignFormSubmit({commit}, data) {
            commit('CHANGE_CAN_SUBMIT', {
                designForm: data.length === 0
            });
        },
        changeIntelFormSubmit({commit}, data) {
            commit('CHANGE_CAN_SUBMIT', {
                intelForm: data
            });
        },
        changeTargetCount({commit}, data) {
            commit('CHANGE_TARGET_COUNT', data);
        },
        updateCommonState({commit}, {key, value}) {
            commit('UPDATE_COMMON_STATE', {
                key,
                value
            });
        },
        updateMultipleState({commit}, data) {
            commit('UPDATE_MULTIPLE_STATES', data);
        },
        // 获取图片常量数据，行业选项需要用到
        async getImageTplConstants({commit, state}, model) {
            try {
                const resData = await model.imageCreate.getImageTplConstants({productLine: 'QINGDUO'});
                // ToDo，如果行业不是直接使用常量list，而是要有个性化逻辑的话，需要在这里进行重定义，或者直接改成静态配置options
                const allIndustryList = resData?.industry?.map(item => {
                    return {
                        value: `${item.index > 1 ? item.index : ''}`,
                        label: item.label === '全部' ? '全部行业' : item.label
                    };
                });
                const industryList = openIndustryByHot.map(label => {
                    return allIndustryList.find(item => item.label === label);
                }).filter(item => item !== undefined);

                let designFormConfig = state.designFormConfig;
                let industryIndex = designFormConfig.findIndex(item => item.name === 'templateGroup');
                designFormConfig[industryIndex].params.industryOptions = industryList;

                commit('UPDATE_MULTIPLE_STATES', [
                    {
                        key: 'designFormConfig',
                        value: designFormConfig
                    },
                    {
                        key: 'industryList',
                        value: industryList
                    }
                ]);
            }
            catch (err) {
                throw err;
            }
        },
        resetFromData({commit}, resetTab) {
            const form = `${resetTab}Data`;
            const formVal = cloneDeep(
                resetTab === 'intelForm'
                ? defaultIntelFormData : defaultDesignFormData
            );
            const targetVal = cloneDeep(
                resetTab === 'intelForm'
                ? defaultIntelTarget : defaultDesignTarget
            );
            commit('UPDATE_MULTIPLE_STATES', [
                {
                    key: form,
                    value: formVal
                },
                {
                    key: 'toolBarLoading',
                    value: false
                }
            ]);
            commit('CHANGE_TARGET_COUNT', {
                form: resetTab,
                value: targetVal
            });
            resetTab === 'intelForm'
            && commit('CHANGE_CAN_SUBMIT', {
                intelForm: false
            });
        },
        async getImageOutDesc(_, {model, params}) {
            try {
                const res = await model.imageCreate.getImageOutDesc({refImage: params.refImage});
                return res.result || '';
            }
            catch (error) {
                console.error(error);
                return '';
            }
        },
        async handleIntelFormSubmitOld({commit, dispatch, state}, {model, data: {
            type, params, templateCreated, outerTargetCount
        }}) {
            const {targetCountData, intelFormData, designFormData} = state;
            const targetCount = targetCountData.intelForm.targetCount;
            const ext = {
                targetCountData,
                intelFormData,
                designFormData,
                basePrompt: params.basePrompt,
                dataAnalysis: {promptType: params.promptType}
            };
            const baseDisplayImg = Array.from({
                length: templateCreated ? outerTargetCount : targetCount
            }, (_, i) => createImageObject({
                recordId: i,
                ratioNum: params.ratioNum
            }));

            commit('UPDATE_COMMON_STATE', {
                key: 'displayImg',
                value: baseDisplayImg
            });

            // 有参考图且用户没有输入Prompt的情况，前端调用aption能力带入prompt，用户无感
            params.refImage
            && !params.backgroundPrompt
            && (params.backgroundPrompt = await dispatch('getImageOutDesc', {model, params}));

            const finalParams = {
                ...params,
                targetCount,
                textInherit: params.refMode === 'semantic_text',
                ext: JSON.stringify(ext)
            };
            try {
                let displayImg = state.displayImg instanceof Array ? state.displayImg : [];
                const {taskId} = await model.imageCreate.getAsyncTaskId(finalParams);
                let curCount = 0;
                let finish = false; // 任务完成标志位，用于跳出循环
                while (curCount < targetCount && !finish) {
                    const res = await model.imageCreate.intelligentGenImageV2Async(taskId, curCount);
                    if (res.taskStatus === 2 || res.taskStatus === 3) {
                        finish = true;
                    }
                    const list = res.records || [];
                    curCount = list.length;
                    // 如果最后一个图片已经生成，则退出循环，避免重复渲染图片导致的抖动问题
                    if (displayImg[displayImg.length - 1]?.url) {
                        break;
                    }
                    // 未完成态，未生成的图片保持加载态占位，避免图片布局变化
                    displayImg = list.map(i => {
                        return createImageObject({
                            url: i.url,
                            recordId: i.recordId,
                            width: i.width,
                            height: i.height,
                            taskId: i.taskId,
                            templateId: i.templateId
                        });
                    }).concat(finish ? [] : displayImg.slice(curCount));
                    const updateInfo = [{
                        key: 'preBgImgList',
                        value: displayImg
                    }];
                    if (!templateCreated) {
                        updateInfo.push(...[
                            {
                                key: 'displayImg',
                                value: displayImg
                            }
                        ]);
                    }
                    commit('UPDATE_MULTIPLE_STATES', updateInfo);
                }
                return displayImg;
            }
            catch (error) {
                // 如果已经有图片生成完成，则不抛出异常
                if (Array.isArray(state.displayImg) && state.displayImg[0]?.url) {
                    const displayImg = state.displayImg.filter(i => i.url);
                    const updateInfo = [{
                        key: 'preBgImgList',
                        value: displayImg
                    }];
                    commit('UPDATE_MULTIPLE_STATES', updateInfo);
                }
                else {
                    throw error;
                }
            }
        },
        createBlankTask({state}, {count, imageGenerateType, extData}) {
            const baseDisplayImg = Array.from({
                length: count
            }, (_, i) => formatRecordData({
                recordId: i
            }));
            let uuid = uniqueId();
            let task = {...formatTaskData({
                taskId: '',
                imageGenerateType,
                basePrompt: extData.basePrompt,
                ext: JSON.stringify(extData),
                records: baseDisplayImg,
                taskStatus: 1,
                isCollapsed: false
            }), uuid};
            let displayImg = state.displayImg;
            displayImg.push(task);
            return task;
        },

        async handleIntelFormSubmit({commit, dispatch, state}, {model, data: {
            type, params, templateCreated, outerTargetCount
        }}) {
            const {targetCountData, intelFormData, designFormData} = state;
            const targetCount = targetCountData.intelForm.targetCount;
            const extData = {
                targetCountData,
                intelFormData,
                designFormData,
                basePrompt: params.basePrompt,
                dataAnalysis: {promptType: params.promptType}
            };
            let task = await dispatch('createBlankTask', {
                count: templateCreated ? outerTargetCount : targetCount,
                imageGenerateType: 'BACKGROUND_V2',
                extData
            });
            try {
                // 有参考图且用户没有输入Prompt的情况，前端调用aption能力带入prompt，用户无感
                params.refImage
                && !params.backgroundPrompt
                && (params.backgroundPrompt = await dispatch('getImageOutDesc', {model, params}));
                const finalParams = {
                    ...params,
                    targetCount,
                    textInherit: params.refMode === 'semantic_text',
                    ext: JSON.stringify(extData)
                };
                const {taskId} = await model.imageCreate.getAsyncTaskId(finalParams);
                task.taskId = taskId;
                return task;
            }
            catch (error) {
                let displayImg = state.displayImg;
                let taskIndex = displayImg.findIndex(i => i.uuid === task.uuid);
                if (taskIndex > -1) {
                    displayImg.splice(taskIndex, 1);
                }
                throw error;
            }
        },
        // submit方法在表单组件里，单独写一个方法更新loading状态，以及结果区的骨架屏数据
        changeLoadingStatus({commit}, {targetCount, ratioNum = 1}) {
            // loading态，且有骨架屏数量，则生成骨架屏的结果区占位数据
            if (typeof targetCount === 'number') {
                const baseDisplayImg = Array.from({
                    length: targetCount
                }, (_, i) => createImageObject({
                    ratioNum: ratioNum,
                    recordId: i
                }));
                commit('UPDATE_COMMON_STATE', {
                    key: 'displayImg',
                    value: baseDisplayImg
                });
            }
        },
        // 在edit表单组件里做完了前置生成图片的动作 ，此处仅负责更新创作结果区的内容
        async handleDesignFormSubmit({commit, state}, {data}) {
            let displayImg = state.displayImg;
            let taskIndex = state.displayImg.findIndex(i => i.uuid === data.uuid);
            displayImg[taskIndex] = Object.assign(displayImg[taskIndex], data);
            commit('UPDATE_COMMON_STATE', {
                key: 'displayImg',
                value: displayImg
            });
        },
        async handleDesignFormSubmitOld({commit}, {data}) {
            const displayImg = data.map(item => createImageObject({
                ...item
            }));
            commit('UPDATE_MULTIPLE_STATES', [
                // 更新展示区图片
                {
                    key: 'displayImg',
                    value: displayImg
                }
            ]);
        },
        // 设置模板比例
        updateTemplateRatio({commit, state, getters}, ratio) {
            const designRatio = state.designFormData.templateGroup.sizeControl.value.ratio;
            const designRatioList = getTplOptions({
                formData: state.designFormData,
                ext: getters.formExt
            });
            if (ratio !== designRatio && checkValueExists(designRatioList, ratio)) {
                const updateData = cloneDeep(state.designFormData.templateGroup);
                updateData.sizeControl.value.ratio = ratio;
                // 切换比例时，清空公共模板列表
                updateData.template.chooseList = [];
                updateData.template.originTemplateList = [];
                // 如果用户没有选择过自定义模板，则展示外部模板选择
                if (!updateData.template?.chooseMyTpl?.length) {
                    updateData.showOuterChoose = true;
                }
                const updateInfo = {
                    form: 'designFormData',
                    key: 'templateGroup',
                    value: updateData
                };
                commit('UPDATE_FORM_DATA', updateInfo);
            }
        }
    },
    getters: {
        formExt: state => {
            return {
                industryList: state.industryList
            };
        }
    }
};
